module.exports = __webpack_public_path__ + "static/media/d4ru.8a722a9f.pdf";